// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3b140634","940":"6c6fe048"}[chunkId] + ".chunk.js";
};